import { useTranslation } from "react-i18next";

const PageNotAllowed = () => {
  const { t } = useTranslation("common");
  return (
    <div className="error-page">
      <section>
        <div className="error-icon ic-none"></div>
        <div className="error-message-wrap">
          <h2>{t("common:pageNotAllowed.title")}</h2>
          <p>{t("common:pageNotAllowed.message")}</p>
        </div>
      </section>
    </div>
  );
};
export default PageNotAllowed;
